import React from 'react'
import { Link } from 'react-router-dom'
import styles from './Table.module.css'


export const TableCard = () => {
    return (
        <div className={styles.table_container}>
            <header className={styles.header}>
                <h1>Download Documents</h1>
                <button>Send Email</button>
            </header>
            <div className={styles.table_wrapper} style={{ overflowX: 'auto' }}>
                <table className={styles.table}>
                    <tr className={styles.table_header} >
                        <th className={styles.title}><h1>File</h1></th>
                        <th className={styles.title}><h1>Owner</h1></th>
                        <th className={styles.title}><h1>Action</h1></th>
                    </tr>
                    <tr className={styles.table_header}>
                        <td className={styles.title}>1. RD T&Cs</td>
                        <td className={styles.title}>
                            <div className={styles.owner}>
                                <i class="fas fa-user-circle"></i>
                                <Link><p>Bagus Dwi Cahya</p></Link>
                            </div>
                        </td>
                        <td className={styles.title}>
                            <div className={styles.buttons_container}>
                                <i class="fas fa-download"></i>
                                <i class="fas fa-trash"></i>
                            </div>
                        </td>
                    </tr>
                    <tr className={styles.table_header}>
                        <td className={styles.title}>2. RDT Brochure</td>
                        <td className={styles.title}>
                            <div className={styles.owner}>
                                <i class="fas fa-user-circle"></i>
                                <Link><p>Bagus Dwi Cahya</p></Link>
                            </div>
                        </td>
                        <td className={styles.title}>
                            <div className={styles.buttons_container}>
                                <i class="fas fa-download"></i>
                                <i class="fas fa-trash"></i>
                            </div>
                        </td>
                    </tr>
                    <tr className={styles.table_header}>
                        <td className={styles.title}>3. Letter of Authority</td>
                        <td className={styles.title}>
                            <div className={styles.owner}>
                                <i class="fas fa-user-circle"></i>
                                <Link><p>Bagus Dwi Cahya</p></Link>
                            </div>
                        </td>
                        <td className={styles.title}>
                            <div className={styles.buttons_container}>
                                <i class="fas fa-download"></i>
                                <i class="fas fa-trash"></i>
                            </div>
                        </td>
                    </tr>
                    <tr className={styles.table_header}>
                        <td className={styles.title}>4. R&D Presentation</td>
                        <td className={styles.title}>
                            <div className={styles.owner}>
                                <i class="fas fa-user-circle"></i>
                                <Link><p>Bagus Dwi Cahya</p></Link>
                            </div>
                        </td>
                        <td className={styles.title}>
                            <div className={styles.buttons_container}>
                                <i class="fas fa-download"></i>
                                <i class="fas fa-trash"></i>
                            </div>
                        </td>
                    </tr>
                    <tr className={styles.table_header}>
                        <td className={styles.title}>5. Bank Details</td>
                        <td className={styles.title}>
                            <div className={styles.owner}>
                                <i class="fas fa-user-circle"></i>
                                <Link><p>Bagus Dwi Cahya</p></Link>
                            </div>
                        </td>
                        <td className={styles.title}>
                            <div className={styles.buttons_container}>
                                <i class="fas fa-download"></i>
                                <i class="fas fa-trash"></i>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>

        </div>
    )
}